var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';

import CheckboxTooltip from './CheckboxTooltip';

import './Checkbox.scss';

var Checkbox = function Checkbox(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        description = _ref.description,
        fieldLabel = _ref.fieldLabel,
        hideLabel = _ref.hideLabel,
        id = _ref.id,
        isChecked = _ref.isChecked,
        isDisabled = _ref.isDisabled,
        label = _ref.label,
        name = _ref.name,
        onChange = _ref.onChange,
        subsection = _ref.subsection,
        tooltip = _ref.tooltip,
        rest = _objectWithoutProperties(_ref, ['className', 'description', 'fieldLabel', 'hideLabel', 'id', 'isChecked', 'isDisabled', 'label', 'name', 'onChange', 'subsection', 'tooltip']);

    var checkboxLabel = React.createElement(
        'label',
        { className: 'checkbox-label' },
        React.createElement('input', _extends({
            id: id,
            disabled: isDisabled,
            name: name,
            onChange: onChange,
            type: 'checkbox',
            checked: isChecked
        }, rest)),
        React.createElement('span', { className: 'checkbox-pointer-target' }),
        React.createElement(
            'span',
            { className: hideLabel ? 'accessibility-hidden' : '' },
            label
        )
    );

    return React.createElement(
        'div',
        {
            className: 'checkbox-container ' + className + ' ' + (isDisabled ? 'is-disabled' : '')
        },
        fieldLabel && React.createElement(
            'div',
            { className: 'label' },
            fieldLabel
        ),
        tooltip ? React.createElement(CheckboxTooltip, { label: checkboxLabel, tooltip: tooltip }) : checkboxLabel,
        description ? React.createElement(
            'div',
            { className: 'checkbox-description' },
            description
        ) : null,
        subsection ? React.createElement(
            'div',
            { className: 'checkbox-subsection' },
            subsection
        ) : null
    );
};

Checkbox.propTypes = {
    className: PropTypes.string,

    /** Description to the checkbox */
    description: PropTypes.node,

    /** Label for the field shown on top of the checkbox */
    fieldLabel: PropTypes.node,

    /** Hides the checkbox label when true */
    hideLabel: PropTypes.bool,

    /** Unique `id` for the input */
    id: PropTypes.string,

    /** Checkbox checked state */
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,

    /** Label displayed for the input */
    label: PropTypes.node.isRequired,

    /** Name of the input */
    name: PropTypes.string.isRequired,

    /** change callback function called with event as the argument */
    onChange: PropTypes.func,

    /** Subsection below the checkbox */
    subsection: PropTypes.node,

    /** Info tooltip text next to the checkbox label */
    tooltip: PropTypes.string
};
export default Checkbox;
import PropTypes from 'prop-types';